import React, { useState, useEffect, useRef } from "react";
import { Button, Dropdown } from "primereact";
import { Link } from "react-router-dom";
import classNames from "classnames";

export const AppTopbar = (props) => {
  const [selectedCountry, setSelectedCountry] = useState(props.lingua);

  const countries = [
    { name: "Italiano", code: "IT" },
    { name: "English", code: "UK" },
  ];

  const countryOptionTemplate = (option) => {
    return (
      <div className="country-item">
        <img
          alt={option.name}
          src="images/flag_placeholder.png"
          onError={(e) => (e.target.src = "https://www.primefaces.org/wp-content/uploads/2020/05/placeholder.png")}
          className={`flag flag-${option.code.toLowerCase()}`}
        />
        <div>{option.name}</div>
      </div>
    );
  };

  const onCountryChange = (e) => {
    setSelectedCountry(e.value);
    props.onLanguageClick(e.value.code);
    document.getElementById("aaGG").innerText = e.value.code;
  };
  const onClickita = (e) => {
    setSelectedCountry({ name: "Italiano", code: "IT" });
    props.onLanguageClick("IT");
    document.getElementById("aaGG").innerText = "IT";
  };

  const onClickeng = (e) => {
    setSelectedCountry({ name: "English", code: "UK" });
    props.onLanguageClick("UK");
    document.getElementById("aaGG").innerText = "UK";
  };

  return (
    <div className="layout-topbar" style={{backgroundColor:"black"}}>
      <div className="col-12 flex justify-content-between">
        {sessionStorage.getItem("ruoloid") && sessionStorage.getItem("ruoloid") != 2 ? (
          <button type="button" className="p-link lg:hidden" onClick={props.onToggleMenuClick}>
            <i className="pi pi-bars" style={{ fontSize: "1.7rem" }} />
          </button>
        ) : (
          ""
        )}

        <div>
          <div id="aaGG" style={{ width: "1px", maxHeight: "1px" }}></div>
          <img style={{ maxHeight: "55pt" }} src="assets/layout/images/header1.png" alt="logo" />
        </div>
    
     
        <div className="flex justify-content-end align-items-center ">
          <button className="p-link layout-topbar-button">
            <Link to="/login">
              <i className={sessionStorage.getItem("isAutenticate") ? "pi pi-sign-out" : "pi pi-user"} />
            </Link>
          </button>
          {!sessionStorage.getItem("ruoloid") ? (
            <>
              <br />
            
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};
